export const allDevicesClearPasswordField = () => {
    $("input[id='reg_checkbox']").on('change', function() {
        if ($(this).prop("checked") == false) {
            $("#create-password").val('');
            $("#verify-choose-password").val('');
        };
    });
};
